export interface RouteLoadStop {
  category?: string;
  weight?: number | string | null;
}

export interface RouteLoad {
  arrivalLoad: number;
  peakLoad: number;
}

export const calculateRouteLoad = (
  stops: RouteLoadStop[],
  originQuantity = 0,
): RouteLoad => {
  let currentLoad = originQuantity;
  let peakLoad = originQuantity;

  stops.forEach((stop) => {
    const weight = Number(stop.weight ?? 0);

    if (stop.category === "LOADING") {
      currentLoad += weight;
      peakLoad = Math.max(peakLoad, currentLoad);
    }

    if (stop.category === "UNLOADING") {
      currentLoad = Math.max(0, currentLoad - weight);
    }
  });

  return { arrivalLoad: currentLoad, peakLoad };
};
